import React from "react"

const QuestionList = [
    {
        "id": "1",
        "question": "What is the capital of India",
        "a": "Mumbai",
        "b": "Delhi",
        "c": "Banglore",
        "d": "Kolkata",
        "answer": "Delhi"
    },
    {
        "id": "2",
        "question": "What is the capital of Jharkhand",
        "a": "Mumbai",
        "b": "Delhi",
        "c": "Ranchi",
        "d": "Kolkata",
        "answer": "Ranchi"
    },
    {
        "id": "3",
        "question": "What is the capital of West Bengal",
        "a": "Mumbai",
        "b": "Delhi",
        "c": "Banglore",
        "d": "Kolkata",
        "answer": "Kolkata"
    },
    {
        "id": "4",
        "question": "What is the capital of Bihar",
        "a": "Patna",
        "b": "Delhi",
        "c": "Banglore",
        "d": "Kolkata",
        "answer": "Patna"
    },
    {
        "question": "What temperature does water boil at?",
        "a": "50 degrees Celcius",
        "b": "25 degrees Celcius",
        "c": "100 degrees Celcius",
        "d": "150 degrees Celcius",
        "answer": "100 degrees Celcius"
    },

    {
        "question": "Who wrote Julius Caesar, Macbeth and Hamlet?",
        "a": "Wole Soyinka",
        "b": "William Shakespeare",
        "c": "Ngozi Chimamanda Adichie",
        "d": "Dan Brown",
        "answer": "William Shakespeare"
    },

    {
        "question": "What did the crocodile swallow in Peter Pan?",
        "a": "A Book",
        "b": "A Computer",
        "c": "A pair of shoes",
        "d": "Alarm Clock",
        "answer": "Alarm Clock"
    },

    {
        "question": "Which is the only mammal that can’t jump?",
        "a": "Dog",
        "b": "Elephant",
        "c": "Goat",
        "d": "Lion",
        "answer": "Elephant"
    },

    {
        "question": "Who lived at 221B, Baker Street, London?",
        "a": "Tony Stark",
        "b": "Morgan Freeman",
        "c": "Sherlock Holmes",
        "d": "Samuel L. Jackson",
        "answer": "Sherlock Holmes"
    },

    {
        "question": "What colour is a panda?",
        "a": "Green and Yellow",
        "b": "Blue and Red",
        "c": "Green and White",
        "d": "Black and White",
        "answer": "Black and White"
    },

    {
        "question": "Where is the smallest bone in the human body?",
        "a": "The Chest",
        "b": "The Ear",
        "c": "The Legs",
        "d": "The Hands",
        "answer": "The Ear"
    },

    {
        "question": "What does the roman numeral C represent?",
        "a": "100",
        "b": "10",
        "c": "10,000",
        "d": "1,000,000",
        "answer": "100"
    },

    {
        "question": "What takes place in Hong Kong's Happy Valley?",
        "a": "Chicken Wrestling",
        "b": "Horse racing",
        "c": "Street Racing",
        "d": "Arm Wrestling",
        "answer": "Horse racing"
    },

    {
        "question": "Who painted the Mona Lisa?",
        "a": "Alexander Graham Bell",
        "b": "Sir Isaac Newton",
        "c": "Leonardo Da Vinci",
        "d": "Albert Einstein",
        "answer": "Leonardo Da Vinci"
    },

    {
        "question": "What’s the most important book in the Muslim religion?",
        "a": "The Kuran",
        "b": "The Dictionary",
        "c": "The Bible",
        "d": "The Chemistry text Book",
        "answer": "The Kuran"
    },

    {
        "question": "What’s the capital of Ethiopia?",
        "a": "Cape Town",
        "b": "Addis Ababa",
        "c": "Abuja",
        "d": "Syndey",
        "answer": "Addis Ababa"
    },

    {
        "question": "How many squares are there on a chess board?",
        "a": "128",
        "b": "64",
        "c": "32",
        "d": "256",
        "answer": "64"
    },

    {
        "question": "Who invented the electric light bulb?",
        "a": "Tom Cruise",
        "b": "Barack Obama",
        "c": "Wole Soyinka",
        "d": "Thomas Edison",
        "answer": "Thomas Edison"
    },

    {
        "question": "What are the first three words of the bible?",
        "a": "be with everyone",
        "b": "Again Jesus asked",
        "c": "In the beginning",
        "d": "At that time",
        "answer": "In the beginning"
    }

]
export default QuestionList;